import React, { useState, useEffect } from 'react';
import './Whatsapp.css';

const Whatsapp = () => {
 

  return (
    <div>
      {/* Uncomment the following line if you want to include the WhatsApp link */}
      <a style={{ marginLeft: "30px" }} href="https://wa.me/+919437086696" className="btn-whatsapp-pulse" target='_blank' rel="noopener noreferrer">
        <i className="fab fa-whatsapp"></i>
      </a>

      
    </div>
  );
}

export default Whatsapp;
